import { SortDirection } from './sort-direction.entity';
import { SortField } from './sort-field.entity';

export interface SortInfo {
    readonly field: string;
    readonly direction: SortDirection;
}

export const relevanceSortInfo: SortInfo = {
    field: SortField.RELEVANCE,
    direction: SortDirection.DESC
};

export const lastModifiedDescSortInfo: SortInfo = {
    field: SortField.LAST_MODIFIED_DATE,
    direction: SortDirection.DESC
};

export const lastModifiedAscSortInfo: SortInfo = {
    field: SortField.LAST_MODIFIED_DATE,
    direction: SortDirection.ASC
};

export const publicationDateAscSortInfo: SortInfo = {
    field: SortField.PUBLICATION_DATE,
    direction: SortDirection.ASC
};

export const publicationDateDescSortInfo: SortInfo = {
    field: SortField.PUBLICATION_DATE,
    direction: SortDirection.DESC
};

export const archiveDateAscSortInfo: SortInfo = {
    field: SortField.ARCHIVE_DATE,
    direction: SortDirection.ASC
};

export const archiveDateDescSortInfo: SortInfo = {
    field: SortField.ARCHIVE_DATE,
    direction: SortDirection.DESC
};

export const creationDateAscSortInfo: SortInfo = {
    field: SortField.CREATION_DATE,
    direction: SortDirection.ASC
};

export const creationDateDescSortInfo: SortInfo = {
    field: SortField.CREATION_DATE,
    direction: SortDirection.DESC
};

export const logicalDeletionDateAscSortInfo: SortInfo = {
    field: SortField.LOGICAL_DELETION_DATE,
    direction: SortDirection.ASC
};

export const logicalDeletionDateDescSortInfo: SortInfo = {
    field: SortField.LOGICAL_DELETION_DATE,
    direction: SortDirection.DESC
};

export const titleAscSortInfo: SortInfo = {
    field: SortField.TITLE,
    direction: SortDirection.ASC
};

export const titleDescSortInfo: SortInfo = {
    field: SortField.TITLE,
    direction: SortDirection.DESC
};

export const originalFilenameAscSortInfo: SortInfo = {
    field: SortField.ORIGINAL_FILENAME,
    direction: SortDirection.ASC
};

export const originalFilenameDescSortInfo: SortInfo = {
    field: SortField.ORIGINAL_FILENAME,
    direction: SortDirection.DESC
};

export const nameAscSortInfo: SortInfo = {
    field: SortField.NAME,
    direction: SortDirection.ASC
};

export const nameDescSortInfo: SortInfo = {
    field: SortField.NAME,
    direction: SortDirection.DESC
};

export const labelAscSortInfo: SortInfo = {
    field: SortField.LABEL,
    direction: SortDirection.ASC
};

export const labelDescSortInfo: SortInfo = {
    field: SortField.LABEL,
    direction: SortDirection.DESC
};

export const startDateAscSortInfo: SortInfo = {
    field: SortField.START_DATE,
    direction: SortDirection.ASC
};

export const startDateDescSortInfo: SortInfo = {
    field: SortField.START_DATE,
    direction: SortDirection.DESC
};

export const finishDateAscSortInfo: SortInfo = {
    field: SortField.FINISH_DATE,
    direction: SortDirection.ASC
};

export const finishDateDescSortInfo: SortInfo = {
    field: SortField.FINISH_DATE,
    direction: SortDirection.DESC
};

export const loginAscSortInfo: SortInfo = {
    field: SortField.LOGIN,
    direction: SortDirection.ASC
};

export const loginDescSortInfo: SortInfo = {
    field: SortField.LOGIN,
    direction: SortDirection.DESC
};

export const firstNameAscSortInfo: SortInfo = {
    field: SortField.FIRST_NAME,
    direction: SortDirection.ASC
};

export const firstNameDescSortInfo: SortInfo = {
    field: SortField.FIRST_NAME,
    direction: SortDirection.DESC
};

export const lastNameAscSortInfo: SortInfo = {
    field: SortField.LAST_NAME,
    direction: SortDirection.ASC
};

export const lastNameDescSortInfo: SortInfo = {
    field: SortField.LAST_NAME,
    direction: SortDirection.DESC
};

export const contentsSortInfo: SortInfo = {
    field: SortField.CHILD_ORDER,
    direction: SortDirection.ASC
};

export const lastLoginDescSortInfo: SortInfo = {
    field: SortField.LAST_LOGIN,
    direction: SortDirection.DESC
};

export const lastLoginAscSortInfo: SortInfo = {
    field: SortField.LAST_LOGIN,
    direction: SortDirection.ASC
};

export const defaultSortInfo: SortInfo = relevanceSortInfo;

export const CONCEPT_SORT_OPTIONS: SortInfo[] = [
    relevanceSortInfo,
    lastModifiedDescSortInfo,
    lastModifiedAscSortInfo,
    archiveDateDescSortInfo,
    archiveDateAscSortInfo,
    creationDateDescSortInfo,
    creationDateAscSortInfo,
    titleAscSortInfo,
    titleDescSortInfo,
    originalFilenameAscSortInfo,
    originalFilenameDescSortInfo
];

export const ALL_SORT_OPTIONS: SortInfo[] = [
    ...CONCEPT_SORT_OPTIONS,
    publicationDateDescSortInfo,
    publicationDateAscSortInfo
];

export const INTELLECTUAL_SORT_OPTIONS: SortInfo[] = [...ALL_SORT_OPTIONS, contentsSortInfo];
